import { api } from '@/galaxy-cruise/api';
import { loginGuard } from '@/galaxy-cruise/utils';
import { validNickname, integerString } from '@/galaxy-cruise/utils/validation';
import { store } from '@/store';
import { Component, Vue, Watch } from "vue-property-decorator";
import PasswordDialog from "./PasswordDialog.vue";
import { AxiosError } from 'axios';
import { UNPROCESSABLE_ENTITY } from 'http-status-codes';

@Component({
  components: {
    PasswordDialog,
  },
})
export default class extends Vue {
  static beforeEnter = loginGuard

  validateAlways = false
  nicknameUnique = true
  // birthYearString = this.user.birth_year && String(this.user.birth_year) || ''

  showPasswordDialog = false

  get user() {
    return this.gc.session!.user
  }

  get gc() {
    return store.galaxyCruise
  }

  @Watch('user.gravatar_private')
  onGravatarPrivageChange() {
    if (!this.user.gravatar_private) {
      this.user.gravatar_public = false
    }
  }

  get nicknameErrors() {
    return [
      (this.user.nickname === null || this.user.nickname.length === 0) && this.$t('cannot_be_blank'),
      !this.nicknameUnique && this.$t('nickname_already_taken'),
    ].filter((e) => e)
  }

  // @Watch('birthYearString')
  // onBirthYearStringChange() {
  //   const { valid, value } = integerString(this.birthYearString)
  //   if (valid) {
  //     this.user.birth_year = value
  //   }
  // }

  // get birthYearErrors() {
  //   return [
  //     this.birthYearString && !integerString(this.birthYearString).valid && '数字を入力してください',
  //   ].filter((e) => e)
  // }

  @Watch('user.nickname', { immediate: true })
  async nicknameChange() {
    this.nicknameUnique = await validNickname(this.user.nickname)
  }

  async submit() {
    if (!this.ok) {
      (this.$refs.dialog as any).shake(() => this.validateAlways = true)
      return
    }

    const user = this.user
    const axios = api.passErrors(UNPROCESSABLE_ENTITY)
    try {
      await axios.put('../api/v1/user', { user })
      this.cancel()
    } catch (e) {
      const error: AxiosError = e
      switch (error.response!.status) {
        case UNPROCESSABLE_ENTITY:
          const errors = error.response!.data
          const message = Object.keys(error.response!.data).map((k) => {
            return errors[k].map((m: string) => `${this.$t(k)}${this.$t(m)}`).join('\n')
          }).join('\n')
          alert(message)
          break
      }
    }
  }

  async cancel() {
    this.$router.push('/')
  }

  get ok() {
    // return this.nicknameErrors.length + this.birthYearErrors.length === 0
    return this.nicknameErrors.length === 0
  }
}
